// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"ApprovalPage_tableWrapper__trsBO","root":"ApprovalPage_root__7lM-B","wrap":"ApprovalPage_wrap__SKbM7"};